module.exports = __webpack_public_path__ + "img/Number=80.1302bc81.png";